import React from "react";
import PropTypes from "prop-types";

import Button from "components/button";

import styles from "./feedback-actions.scss";

const FeedbackActions = ({ onBack, onNext, isNextDisbled, onSubmit, isSubmitDisabled,  onClose }) => {
	return (
		<div className={styles.feedback_actions}>
			{onClose && <Button variant="outlinebtn" displayName="Close" onClick={onClose} />}
			{onBack && <Button variant="outlinebtn" displayName="Back" onClick={onBack} />}
			{onNext && <Button displayName="Next" disabled={isNextDisbled} onClick={onNext} />}
			{onSubmit && <Button displayName="Submit" disabled={isSubmitDisabled} onClick={onSubmit} />}
		</div>
	);
};

FeedbackActions.defaultProps = {

};

FeedbackActions.prototype = {
	onSubmit: PropTypes.func.isRequired
};

export default FeedbackActions;
